import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ReportRowData, TimeseriesReportData, ListItem} from 'nutshell-core/types';

import * as actions from './editions-actions';

type EditionRecipientListState = {
    isLoading: boolean;
    isFirstLoad: boolean;
    errorMessage?: string;
    listItems: any[];
    meta: any;
};

const editionRecipientListDefaultState = {
    isLoading: true,
    isFirstLoad: true,
    errorMessage: undefined,
    listItems: [],
    meta: {},
} as const;

const isFilterDrawerOpen = createReducer(
    {
        // @ts-expect-error
        [actions.toggleShowFilterDrawer]: (state) => !state,
    },
    false
);

export const editionRecipientListReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestEditionRecipientListData]: (state) => {
            return {...state, isLoading: true, errorMessage: undefined};
        },
        // @ts-expect-error
        [actions.updateEditionRecipientListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                isLoading: false,
                isFirstLoad: false,
                meta: meta,
                listItems: listItems
                    ? listItems.map((item: ListItem) => {
                          return {
                              ...item,
                              id: item.links ? item.links.entity.id : item.id,
                          };
                      })
                    : undefined,
                errorMessage: undefined,
            };
        },
        // @ts-expect-error
        [actions.failEditionRecipientListData]: (state, err) => {
            return {...state, isLoading: false, isFirstLoad: false, errorMessage: err};
        },
    },
    editionRecipientListDefaultState
);

type EditionEngagementReportTableData = {
    rows: ReportRowData[] | null | undefined;
    totals: ReportRowData | null | undefined;
};
type EditionEngagementReportState = {
    timeseriesChart: {
        isLoading: boolean;
        isTimedOut: boolean;
        isErrored: boolean;
        chartData: TimeseriesReportData | null | undefined;
        prefix: string;
    };
};
const editionEngagementReportDefaultState = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
} as const;

const editionEngagementReportReducer = createReducer(
    {
        [actions.updateEditionEngagementReportTableData]: (
            // @ts-expect-error
            state,
            payload: EditionEngagementReportTableData
        ) => {
            return {...state, tableData: payload};
        },
        // @ts-expect-error
        [actions.requestEditionEngagementReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.updateEditionEngagementReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failEditionEngagementReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
    },
    editionEngagementReportDefaultState
);

export const editionsReducer = combineReducers({
    editionRecipientList: editionRecipientListReducer,
    editionEngagementReport: editionEngagementReportReducer,
    isFilterDrawerOpen,
});

export type EditionsState = {
    editionRecipientList: EditionRecipientListState;
    editionEngagementReport: EditionEngagementReportState;
    isFilterDrawerOpen: boolean;
};
